import { useEffect, useMemo, useRef, useState } from "react";
import "./winnerTable.scss";
import Select from "react-select";
import { winnersList } from "../../data/data";
import useWindowDimensions from "../../hooks/useWindowDimensions";

const yearOptions = [
  { value: "All", label: "All" },
  { value: "2026", label: "2026" },
  { value: "2025", label: "2025" },
];

const monthOptions = [
  { value: "All", label: "All" },
  { value: "January", label: "January" },
  { value: "February", label: "February" },
  { value: "March", label: "March" },
  { value: "April", label: "April" },
  { value: "May", label: "May" },
  { value: "June", label: "June" },
  { value: "July", label: "July" },
  { value: "August", label: "August" },
  { value: "September", label: "September" },
  { value: "October", label: "October" },
  { value: "November", label: "November" },
  { value: "December", label: "December" },
];

const WinnerTable = () => {
  const { width } = useWindowDimensions();
  const tableRef = useRef(null);
  const [selectedYear, setSelectedYear] = useState({
    value: "All",
    label: "All",
  });
  const [selectedMonth, setSelectedMonth] = useState({
    value: "All",
    label: "All",
  });

  const allYears = [...new Set(winnersList.map((item) => item.year))];
  const allMonths = [...new Set(winnersList.map((item) => item.month))];

  const monthOrder = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthOptions = useMemo(() => {
    let months = allMonths;

    if (selectedYear && selectedYear.value !== "All") {
      // Get months that appear in the selected year
      months = [
        ...new Set(
          winnersList
            .filter((item) => item.year === Number(selectedYear.value))
            .map((item) => item.month),
        ),
      ];
    }

    months.sort((a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b));

    return [
      { value: "All", label: "All" },
      ...months.map((m) => ({ value: m, label: m })),
    ];
  }, [selectedYear]);

  // const yearOptions = useMemo(() => {
  //   let years = allYears;

  //   if (selectedMonth && selectedMonth.value !== "All") {
  //     // Get years that have the selected month
  //     years = [
  //       ...new Set(
  //         winnersList
  //           .filter((item) => item.month === selectedMonth.value)
  //           .map((item) => item.year),
  //       ),
  //     ];
  //   }

  //   // Sort descending (latest first)
  //   years.sort((a, b) => b - a);

  //   return [
  //     { value: "All", label: "All" },
  //     ...years.map((y) => ({ value: String(y), label: String(y) })),
  //   ];
  // }, [selectedMonth]);

  const filteredWinners = winnersList
    .filter((item) => {
      const matchYear =
        !selectedYear ||
        selectedYear.value === "All" ||
        item.year === Number(selectedYear.value);

      const matchMonth =
        !selectedMonth ||
        selectedMonth.value === "All" ||
        item.month === selectedMonth.value;

      return matchYear && matchMonth;
    })
    .sort((a, b) => {
      // Sort by year descending
      if (a.year !== b.year) return b.year - a.year;

      // Sort by month descending (latest month first)
      return monthOrder.indexOf(b.month) - monthOrder.indexOf(a.month);

      // Sort by year ascending
      // if (a.year !== b.year) return a.year - b.year;

      // Sort by month ascending (latest month first)
      // return monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month);
    });

  // Reset horizontal scroll when filters change
  useEffect(() => {
    if (width <= 767 && tableRef.current) {
      tableRef.current.scrollLeft = 0;
    }
  }, [selectedMonth, selectedYear]);

  return (
    <>
      <div className={`winnerTable_container`}>
        <div className="my_container">
          <div className="text_container">
            <h2 className="section_title">Winners</h2>
            <form className="form_wrapper" onSubmit={(e) => e.preventDefault()}>
              <div className="form_box">
                <div className="form_field">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    // defaultValue={selectedYear}
                    value={selectedYear}
                    options={yearOptions}
                    placeholder="All"
                    // onChange={(value) => setSelectedYear(value)}
                    onChange={(value) => {
                      if (value.value !== selectedYear.value) {
                        setSelectedYear(value);
                        setSelectedMonth({ value: "All", label: "All" }); // reset month
                      }
                    }}
                    isSearchable={false}
                    name="year"
                  />
                  {/* {errors.state && (
                  <div className="error_message">{errors.state}</div>
                )} */}
                </div>
              </div>
              <div className="form_box">
                <div className="form_field">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    // defaultValue={selectedMonth}
                    value={selectedMonth}
                    options={monthOptions}
                    placeholder="All"
                    // onChange={(value) => setSelectedMonth(value)}
                    onChange={(value) => {
                      setSelectedMonth(value);
                    }}
                    isSearchable={false}
                    name="month"
                  />
                  {/* {errors.state && (
                  <div className="error_message">{errors.state}</div>
                )} */}
                </div>
              </div>
            </form>
          </div>

          <div className="mobile_scroll_indicator">
            <p className="scroll_text">Scroll Right</p>
          </div>
        </div>

        <div className="main_table_container">
          <div className="my_container">
            <div className="main_table_wrapper">
              <div
                className={`table_container ${
                  filteredWinners.length === 0
                    ? "table_container_noresults"
                    : ""
                }`}
                ref={tableRef}
              >
                <table className="table_wrapper">
                  <thead className="table_heading">
                    <tr>
                      <th>Sr. No.</th>
                      <th>Full Name</th>
                      <th>Views</th>
                      <th>Prize Name</th>
                      <th>Month & Year</th>
                    </tr>
                  </thead>
                  <tbody className="table_body">
                    {filteredWinners.length > 0 ? (
                      filteredWinners.map((item, index) => (
                        <tr key={`winner-${index}`}>
                          <td>{String(index + 1).padStart(2, "0")}.</td>
                          <td>{item.name}</td>
                          <td className="views_datacol">{item.views}</td>
                          <td>{item.prize}</td>
                          <td>
                            {item.month.slice(0, 3)}-
                            {item.year.toString().slice(-2)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="not_found_text">
                          No winners found for {selectedMonth?.label}{" "}
                          {selectedYear?.label}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WinnerTable;
